import React, { useMemo, useState } from "react";

const GOLD_VALUE_LEADS_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzsm9GpSFkpXhXIdCAwkrxmvZiCwocLluAz3qFQ1QQ3vSFP3DATlZZfk4MieBCcN5LI/exec";

const serviceOptions = [
  "Sell Gold for Cash",
  "Release Pledged Gold",
  "Gold Valuation",
  "Sell Gold From Home",
];

const sanitizeOnlyLetters = (value) => {
  return value
    .replace(/[^A-Za-z\s]/g, "")
    .replace(/\s{2,}/g, " ")
    .replace(/^\s+/, "");
};

const sanitizeOnlyNumbers = (value) => {
  return value.replace(/\D/g, "").slice(0, 10);
};

export default function GoldValueContactSection({
  locationText = "Bangalore",
  mapLink = "https://www.google.com/maps/search/?api=1&query=G1+Gold+Bangalore",
}) {
  const [formLoading, setFormLoading] = useState(false);
  const [formTouched, setFormTouched] = useState(false);

const [formData, setFormData] = useState({
  fullName: "",
  mobileNumber: "",
  service: "",
  message: "",
});

const formReady = useMemo(() => {
  const name = formData.fullName.trim();
  const mobile = formData.mobileNumber.trim();
  const service = formData.service.trim();

  return (
    name.length >= 2 &&
    /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(name) &&
    /^\d{10}$/.test(mobile) &&
    service !== ""
  );
}, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormTouched(true);

    if (name === "fullName" || name === "message") {
      setFormData((prev) => ({
        ...prev,
        [name]: sanitizeOnlyLetters(value),
      }));
      return;
    }

    if (name === "mobileNumber") {
      setFormData((prev) => ({
        ...prev,
        [name]: sanitizeOnlyNumbers(value),
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formReady) {
    alert("Please fill all required fields.");
      return;
    }

    const payload = {
      name: formData.fullName.trim(),
      phoneNumber: formData.mobileNumber.trim(),
      source: formData.service,
      message: formData.message.trim() || "Need gold value assistance",
      location: locationText,
      pageUrl: window.location.href,
      formType: "Gold Value CTA Form",
      sheetName: "Gold Value Leads",
    };

    try {
      setFormLoading(true);

      await fetch(GOLD_VALUE_LEADS_SCRIPT_URL, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "text/plain;charset=utf-8",
        },
        body: JSON.stringify(payload),
      });

      alert("Submitted Successfully");

      setFormData({
        fullName: "",
        mobileNumber: "",
        service: "Sell Gold for Cash",
        message: "",
      });

      setFormTouched(false);
    } catch (error) {
      console.error("Submit error:", error);
      alert("Submission failed. Please try again.");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <section
      id="gold-value-contact-section"
      className="relative overflow-hidden bg-white py-14 lg:py-16"
    >
      <div className="relative mx-auto max-w-[1450px] px-5 sm:px-6 lg:px-10">
        <div className="overflow-hidden rounded-[28px] border border-[#ead8a8] bg-gradient-to-br from-[#fffdf7] via-white to-[#fff7df] shadow-[0_24px_70px_rgba(20,33,61,0.09)]">
          <div className="grid items-center gap-8 px-5 py-10 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:px-12 lg:py-12">
            <div>
              <p className="inline-flex rounded-full border border-[#d7a51f]/30 bg-[#fff4cf] px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.22em] text-[#b68b22]">
                Contact G1 Gold
              </p>

              <h2 className="mt-5 max-w-[620px] text-[28px] font-extrabold leading-tight text-[#081225] sm:text-[36px] lg:text-[44px]">
                Get Today’s Gold Value in{" "}
                <span className="text-[#c88908]">{locationText}</span>
              </h2>

              <p className="mt-5 max-w-[620px] text-[15px] font-medium leading-7 text-[#334155] sm:text-[16px]">
                Share your details and our team will help you with gold value,
                purity checking, transparent valuation and quick payment support.
              </p>

              <div className="mt-7 grid gap-4 sm:grid-cols-2">
                <a
                  href="tel:+917996800900"
                  className="inline-flex min-h-[54px] items-center justify-center rounded-full bg-gradient-to-r from-[#c88908] to-[#dfaa1c] px-6 py-3 text-[16px] font-extrabold text-white"
                >
                  Call Now
                </a>

                <a
                  href={`https://wa.me/917996800900?text=${encodeURIComponent(
                    `Hi G1 Gold, I want to sell gold in ${locationText}. Please share today's gold value.`
                  )}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-[54px] items-center justify-center rounded-full border border-[#ead8a8] bg-white px-6 py-3 text-[16px] font-extrabold text-[#06152f]"
                >
                  WhatsApp
                </a>

                <a
                  href={mapLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-[54px] items-center justify-center rounded-full border border-[#111b3a]/30 bg-white px-6 py-3 text-[16px] font-extrabold text-[#06152f] sm:col-span-2"
                >
                  Get Directions
                </a>
              </div>
            </div>

          <div className="rounded-[24px] border border-[#ead8a8] bg-white/85 p-5 shadow-[0_25px_70px_rgba(20,33,61,0.10)] sm:p-7 lg:p-8">
  <form className="space-y-5" onSubmit={handleSubmit}>

    <input
      type="text"
      name="fullName"
      value={formData.fullName}
      onChange={handleChange}
      placeholder="Full Name *"
      required
      className="min-h-[62px] w-full rounded-[12px] border border-[#d9dee8] px-5 text-[15px] font-semibold outline-none focus:border-[#d7a51f]"
    />

    <input
      type="tel"
      name="mobileNumber"
      value={formData.mobileNumber}
      onChange={handleChange}
      placeholder="Mobile Number *"
      required
      className="min-h-[62px] w-full rounded-[12px] border border-[#d9dee8] px-5 text-[15px] font-semibold outline-none focus:border-[#d7a51f]"
    />

    <select
      name="service"
      value={formData.service}
      onChange={handleChange}
      required
      className="min-h-[62px] w-full rounded-[12px] border border-[#d9dee8] px-5 text-[15px] font-semibold outline-none focus:border-[#d7a51f]"
    >
      <option value="">Select Service *</option>

      {serviceOptions.map((service) => (
        <option key={service} value={service}>
          {service}
        </option>
      ))}
    </select>

    <input
      type="text"
      name="message"
      value={formData.message}
      onChange={handleChange}
      placeholder="Type your Location"
      className="min-h-[62px] w-full rounded-[12px] border border-[#d9dee8] px-5 text-[15px] font-semibold outline-none focus:border-[#d7a51f]"
    />

    <button
      type="submit"
      disabled={formLoading || !formTouched || !formReady}
      className="min-h-[64px] w-full rounded-[12px] bg-gradient-to-r from-[#e4aa08] to-[#c58500] px-6 py-4 text-[19px] font-extrabold text-white disabled:cursor-not-allowed disabled:opacity-60"
    >
      {formLoading ? "Submitting..." : "Get Gold Value Now"}
    </button>

  </form>
</div>
          </div>
        </div>
      </div>
    </section>
  );
}